export default __webpack_public_path__ + "7b2d6bb6a13c36a44602440dbd070160.svg";